import { useEffect, useReducer, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Card, Tab, Button, Badge, Nav, Collapse, Fade, OverlayTrigger, Tooltip } from "react-bootstrap";
import feedbackIcon from 'Images/feedbackloop.svg';
import { IconButton, IconTextButton, LinkButton, TextButton } from 'Components/Button';
import { http } from "Utils";
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import { ERROR_MESSAGES, SPECIAL_CHARS_PATTERN } from "Utils/constants";
import GeneralComment from "./GeneralComment/GeneralComment";
import SearchBar from "./SearchBar/SearchBar-Notmodal";
import EventTypeSelection from "./EventTypeSelection";
import EventTypeHeader from "./EventTypeHeader";
import { ACTIONS, commentInputDataReducer } from "./FormData/CommentsReducer";
import { commentsMatch, convertCTResp, getCFName, getCFNameByID, getCFSplitName, getCommentTempInputData, getErrorList, getModuleDataByDocIdandCatId, getModuleDataByModuleId, logS, removeExtrasFromItemNum, validateCommentAPI } from "./Util/Utilities";
import { textInputDataReducer } from "Components/Forms/FormReducers/TextInputReducer";
import ItemList from "./Accordion/ItemList";
import { COMMENT_ACTIONS, commentStateReducer } from "./FormData/CommentStateReducer";
import ThankYou from "./GeneralComment/ThankYou";
import StatusPopup from "./Util/StatusPopup";
import { ICONS } from "Utils/icons";
import { store } from "Store";
import { useLocation  } from "react-router-dom";
import { logger, LOGGER } from "Utils/Debug/debugUtils";
import { config } from "Utils/config";
import {ReCaptchaWrapper} from "../../../Components/ReCaptcha";


var activeStart = [];

const OpenForComment = () => {
    const dispatch = useDispatch();
    const debug = false;
    const [isLoading, setIsLoading] = useState(true);
    
    const location = useLocation();
    const defaultPassedCF = location?.state?.cfVersion;
    const defaultPassedMod = location?.state?.cfModule;
    
    const defaultCF = (location?.state)?.hasOwnProperty('cfVersion') ? defaultPassedCF : 29; //Diagnostic Safety
    const defaultMod = (location?.state)?.hasOwnProperty('cfModule') ? defaultPassedMod : null; //4032
    
    const [defaultSearchTerm,setDefaultSearchTerm] = useState((location?.state)?.hasOwnProperty('searchTerm') ? location.state.searchTerm : null);
    const [defaultFocusItem, setDefaultFocusItem] = useState((location?.state)?.hasOwnProperty('focusItem') ? location.state.focusItem : null);
    
    //Common Formats Version Handling
    const [comonFormatsList, setComonFormatsList] = useState(null);
    const [tabActiveKey, setTabActiveKey] = useState(defaultCF != null ? defaultCF : 0);
    const cfDropBtnRef = useRef(0)
    const [isCFDropdownOpen, setIsCFDropdownOpen] = useState(false);
    const [moduleCount, setModuleCount] = useState(null);

    //CF Version Module Handling
    const moduleHeaderRef = useRef(null);
    const [eventTypeList, setEventTypeList] = useState(null);
    const [eventTypeActiveKey, setEventTypeActiveKey] = useState(defaultMod!=null ? defaultMod : null);
    const [catModuleData, setCatModuleData] = useState(null);

    //Comments Handling
    var [commentInput, commentInputDispatch] =  useReducer(textInputDataReducer, {});
    var [tempCommentList, tempCommentListDispatch] =  useReducer(commentStateReducer, {}); //Temporary storage for comment while modifying before it is saved to commentsList
    var [commentsList, commentsListDispatch] =  useReducer(commentInputDataReducer, {});
    const [activeCommentKey, setActiveCommentKey] = useState(defaultFocusItem);

   

    var feedbackInputObj = {
        type: 'textarea',
        id: "feedback",
        name: "feedback",
        value: "",
        count: "".substring(0,2000).length,
        display: {
            label: "General Feedback on the Common Formats",
            description: null,
            title: null,
            placeholder: "Please enter your comment here.. It must be at least 25 characters long.",
            maxLength: 2000,
            rows: 10,
            cols: 90,
            hasCounter: true
        },
        validation: {
            required: true,
            isInvalid: false,
            errors: [],
            isValid: false,
            successMsgs: []
        },
        disabled: false,
        readOnly: false,
        
        InputRef: useRef(null)
    };
    const [generalFeedback, generalFeedbackInputDispatch] =  useReducer(textInputDataReducer, feedbackInputObj);

    //Accordion Handling
    const [activeAccordion, setActiveAccordion] = useState([]);
    const [allOpen, setAllOpen] = useState(null);

    //Item Handling
    const [itemListRefs, setItemListRefs] =  useState({});
    const [events, setEvents] = useState({});
    const [moduleItems, setModuleItems] = useState(null);
    const [activeEl, setActiveEl] = useState(null);
    
    //Popup Handling
    const [statusVariant,setStatusVariant] = useState(null);
    const [statusData,setStatusData]=useState({
        title: "",
        message: "",
        buttons: null
    });
    const [showThankYouPopup, setShowThankYouPopup] = useState(false);
    const [showStatusPopup, setShowStatusPopup] = useState(true);

    
    //Search Feature
    const [highlighted, setHighlighted] = useState({});
    const [focusKeywordId, setFocusKeywordId] = useState(null);
    const [itemIndexes, setItemIndexes] = useState({});
    const [activeSearch, setActiveSearch] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [resultCategories, setResultCategories] = useState([]);
    const [resultIndex, setResultIndex] = useState(0);

    const [itemIds, setItemIds] = useState([]);
    
    const [mobile, setMobile] = useState(null);
    const [isSticky, setIsSticky] = useState(false);



    const iconRef = useRef(null);
    const scrollRef = useRef(null);
    const sentinelRef = useRef(null);
    const sentinelExitRef = useRef(null);
    const options = {
        root: null,
        threshold: [0,1], // Fires as soon as a single pixel crosses the boundary
        rootMargin: "0px",
    };

      

    const handleThankYouClose = () => {
        setShowThankYouPopup(false);
    }
    const handleStatusClose = () => {
        setShowStatusPopup(false);
    }

    useEffect(() => {
        if(debug==true){
            logger.enableLogger();
        }
        else{
            logger.disableLogger();
        }
        getModuleCount();
        const handleResize = () => {
            setMobile(window.innerWidth <= 575.98);
        };
        handleResize();

        //If state vars passed, apply values
        if(tabActiveKey!=0){
            handleCatTabChange(defaultCF,defaultMod);
        }
        if(defaultSearchTerm!=null && defaultSearchTerm!=""){
            setSearchTerm(defaultSearchTerm);
            setActiveSearch(true);
            setDefaultSearchTerm(null);
        }
        
        window.addEventListener("resize", handleResize)
        return () => window.removeEventListener("resize", handleResize)
    }, [])

    const getModuleCount = async () => {
        var url = '/api/ag/ct/catModuleCount';
        const res = http.post(url, null,{
            timeout: 65000, 
            headers: {
                
            }
        }).then((response) => {
            //console.log(response);
            if(response != null ){
                var statusCode = response.status;
                if(statusCode != 1){
                    setGlobalErrorStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true, 
                            title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                            msg: response.globalErrorMessageList != null && response.globalErrorMessageList.length>0 ? response.globalErrorMessageList : ERROR_MESSAGES.GENERAL_ERROR.message, 
                            showContactHelp: false 
                        },
                        redirect: {
                            redirect: false, 
                            redirectFirst: false,
                            path: "", 
                            data: {}
                        }
                    });
                }
                else {
                    setModuleCount(response.data.data);
                } 
            }
            else{
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true, 
                        title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                        msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                        showContactHelp: true 
                    },
                    redirect: {
                        redirect: false, 
                        redirectFirst: false,
                        path: "", 
                        data: {}
                    }
                });
            }
            setIsLoading(false);
        }).catch(function (error) {
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true, 
                    title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                    showContactHelp: true 
                },
                redirect: {
                    redirect: false, 
                    redirectFirst: false,
                    path: "", 
                    data: {}
                },
                error: error
            });
        });
        return res;
    };
    
    const getSearchModuleData = async (keyword, moduleId) => {
        var url = '/api/ag/ct/keywordModule';
        const loginState = store.getState().loginInfo;
        
        keyword=keyword.replace(SPECIAL_CHARS_PATTERN, "\\$&");

        var params = {
            moduleId: moduleId,
            keyword: keyword
        }
        
        const res = http.post(url, null,{
            timeout: 65000, // Set a timeout of 5 seconds,
            headers: {
                "Authorization": "Bearer " + loginState.token
            },
            params: params
        }).then((response) => {
            if(response != null ){
                var statusCode = response.status;
                if(statusCode != 1){
                    setGlobalErrorStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true, 
                            title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                            msg: response.globalErrorMessageList != null && response.globalErrorMessageList.length>0 ? response.globalErrorMessageList : ERROR_MESSAGES.GENERAL_ERROR.message, 
                            showContactHelp: false 
                        },
                        redirect: {
                            redirect: false, 
                            redirectFirst: false,
                            path: "", 
                            data: {}
                        }
                    });
                }
                return response;
            }
            else{
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true, 
                        title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                        msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                        showContactHelp: true 
                    },
                    redirect: {
                        redirect: false, 
                        redirectFirst: false,
                        path: "", 
                        data: {}
                    }
                });
            }
            setIsLoading(false);
        }).catch(function (error) {
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true, 
                    title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                    showContactHelp: true 
                },
                redirect: {
                    redirect: false, 
                    redirectFirst: false,
                    path: "", 
                    data: {}
                },
                error: error
            });
        });
        return res;
    };

    const confirmCatTabChange = (e, module) => {
        if(tabActiveKey!=null && tabActiveKey!=0){
            var tempLength = Object.entries(tempCommentList)?.length;
            if(tempLength!=null && tempLength>0){
                setStatusData({
                    title: "Comments have not yet been submitted!",
                    message: "You may only enter comments for one version at a time. Are you sure you want to navigate away? There are unsubmitted comments. If you leave, your comments will be lost.",
                    buttons: [
                        {
                            text: "Stay Here",
                            action: handleStatusClose,
                            variant: "comp-primary",
                            size: "lg",
                        },
                        {
                            text: "Discard Comments",
                            action: ()=>{
                                handleCatTabChange(e,module);
                                handleStatusClose();
                            },
                            variant: "comp-outline",
                            size: "lg",
                        }
                    ]
                })
                setStatusVariant("warning");
                setShowStatusPopup(true); 
            }
            else{
                handleCatTabChange(e,module);
            }
        }
        else{
            var tempLength = generalFeedback.count;
            if(tempLength!=null && tempLength>0){
                setStatusData({
                    title: "Comments have not yet been submitted!",
                    message: "You may only enter comments for one version at a time. Are you sure you want to navigate away? There are unsubmitted comments. If you leave, your comments will be lost.",
                    buttons: [
                        {
                            text: "Stay Here",
                            action: handleStatusClose,
                            variant: "comp-primary",
                            size: "lg",
                        },
                        {
                            text: "Discard Comments",
                            action: ()=>{
                                handleCatTabChange(e,module);
                                handleStatusClose();
                            },
                            variant: "comp-outline",
                            size: "lg",
                        }
                    ]
                })
                setStatusVariant("warning");
                setShowStatusPopup(true); 
            }
            else{
                handleCatTabChange(e,module);
            }
        }
    }

    const handleCatTabChange = (e, module) => {
        if(tabActiveKey!=0){
            commentsListDispatch({
                type: "clear"
            });
            tempCommentListDispatch({
                type: "clear"
            });
        }
        else{
            generalFeedbackInputDispatch({
                type: ACTIONS.TEXT_AREA_CHANGE,
                value: "",
                maxLength: 2000,
                name: generalFeedback.name
            })
        }

        setIsLoading(true);
        setTabActiveKey(e);
        
        if (e != 0) {
            getModuleList(e,module);
        }

    }

    const handleSearchGetItems = (eventTypeActiveKey) => {
        if(activeSearch!=null && activeSearch==true){
            //console.log(resultCategories);
            
            var currentModule = getModuleDataByDocIdandCatId(eventTypeActiveKey, tabActiveKey, resultCategories);

            if(currentModule!=null){
                setResultIndex(0);
                setFocusKeywordId(null);
                getSearchModuleData(searchTerm,currentModule.moduleId).then((e)=>{
                    setActiveSearch(true);

                    var data = e.data.data;
                    var nums = {};
                    nums.term=searchTerm;
                    
                    for(var x = 0 ; x<data.length ; x++){
                        var exists = itemIds.includes(data[x].itemId);
                        if(exists==true){
                            nums[data[x].itemId]=data[x];
                        }
                    }

                    setHighlighted(nums);
                    setFocusKeywordId(null);

                    var itemIndexes = {};
                    var currentIndex = 0;
                    var keys = Object.keys(nums);
                    
                    for(var x = 0 ; x< keys.length ; x++){
                        if(keys[x]!="term"){
                            var c = nums[keys[x]];
                            for(var y = 0 ; y<c.itemKeywordOccurrence ; y++){
                                itemIndexes[currentIndex]={
                                    id: c.itemId,
                                    occ: y+1
                                };
                                currentIndex=currentIndex + 1;
                            }
                        }
                    }
                    setItemIndexes(itemIndexes);
                });
            }
        }
    }

    const confirmModuleChange = (e) => {
        var tempLength = Object.entries(tempCommentList)?.length;
        if(tempLength!=null && tempLength>0){
            setStatusData({
                title: "Comments have not yet been submitted!",
                message: "You may only enter comments for one version at a time. Are you sure you want to navigate away? There are unsubmitted comments. If you leave, your comments will be lost.",
                buttons: [
                    {
                        text: "Stay Here",
                        action: handleStatusClose,
                        variant: "comp-primary",
                        size: "lg",
                    },
                    {
                        text: "Discard Comments",
                        action: ()=>{
                            handleModuleChange(e);
                            handleStatusClose();
                        },
                        variant: "comp-outline",
                        size: "lg",
                    }
                ]
            })
            setStatusVariant("warning");
            setShowStatusPopup(true); 
        }
        else{
            handleModuleChange(e);
        }
    }
    const handleModuleChange = (e) => {
        commentsListDispatch({
            type: "clear"
        });
        tempCommentListDispatch({
            type: "clear"
        });
        setEventTypeActiveKey(e.id);
        setCatModuleData(e);
        getItemsList(e.groupId);
    }

    useEffect(() => {
        getCategoryList();
    }, []);

    useEffect(()=>{
        handleSearchGetItems(eventTypeActiveKey);
    },[moduleItems, resultCategories])

    const getCategoryList = async () => {
        config.isDebugEnabled && console.log("%cAPI - %c%s", logS.bold, logS.colors.skyblye, "Get Common Formats List");
        const call = async () => {
            var url = "/api/ag/ct/docCatList";
            return http.post(url, null);
        }
        return call().then((res) => {
            //console.log("getCategoryList ", res);
            if (res.status != 1) {
                setStatusData({
                    title: ERROR_MESSAGES.DATA_ERROR.title,
                    message: res.globalErrorMessageList[0],
                    showContactHelp: true
                })
                setStatusVariant("error");
                setShowStatusPopup(true); 
            }
            else {
                setComonFormatsList(res?.data?.data);
            }
            return res;
        }).catch((err)=>{
            setStatusData({
                title: ERROR_MESSAGES.DATA_ERROR.title,
                message: ERROR_MESSAGES.DATA_ERROR.message,
                showContactHelp: true
            })
            setStatusVariant("error");
            setShowStatusPopup(true); 
        });
    }

    const getModuleList = async (catId, module) => {
        config.isDebugEnabled && console.log("%cAPI - %c%s%c: \n%cCommon Formats Version:%c\n%s - %s", logS.bold, logS.colors.skyblye, "Get Module List",logS.none, logS.bold, logS.none, catId, getCFNameByID(catId, comonFormatsList));
        const call = async () => {
            var url = "/api/ag/ct/document/list/module/" + catId;
            return http.post(url, null);
        }
        return call().then((resp) => { 
            if(resp!=null){
                var res = convertCTResp(resp);
                
                if (res.status != 1) {
                    setStatusData({
                        title: ERROR_MESSAGES.DATA_ERROR.title,
                        message: res.globalErrorMessageList[0],
                        showContactHelp: true
                    })
                    setStatusVariant("error");
                    setShowStatusPopup(true); 

                }
                else {
                    var catmod = res.data;
                    var catmodlist = [];

                    for(var x = 0 ; x<catmod.length ; x++){
                        var i = catmod[x];
                        if(i!=null){
                            if(i.subModuleName==null){
                                catmodlist.push(i);
                            }
                            else{
                                if(catmodlist.some(e => e.moduleName === i.moduleName)){
                                    //console.log("contains");
                                }
                                else{
                                    var subMod = catmod.filter(a => a!=null && a.moduleName==i.moduleName);
                                    catmodlist.push({
                                        moduleName: i.moduleName,
                                        subs: subMod
                                    });
                                }
                                
                            }
                        }
                    }
                    setEventTypeList(catmodlist);

                    if(module!=null){
                        var i = getModuleDataByModuleId(module,res.data);
                        //console.log(res.data, module, i);
                        setEventTypeActiveKey(module);
                        setCatModuleData(i);
                        getItemsList(i.groupId);
                    }
                    else{
                        setEventTypeActiveKey(((res.data)[0]).id)
                        setCatModuleData(((res.data)[0]));
                        getItemsList(((res.data)[0]).groupId);
                    }
                    setIsLoading(false);
                }
            }
            return res;
        }).catch((error) => {
            config.isDebugEnabled && console.log("Error caught while loading data: " + error);

            setStatusData({
                title: ERROR_MESSAGES.DATA_ERROR.title,
                message: ERROR_MESSAGES.DATA_ERROR.message,
                showContactHelp: true
            })
            setStatusVariant("error");
            setShowStatusPopup(true); 
        });
    }

    var items = {};

    const getItemsList = async (groupId) => {
        function addNestedProperty(obj, path, keyToAdd, valueToAdd) {
            // Base case: If the path is empty, we are at the target object.
            if (path.length === 0) {
                if (obj.hasOwnProperty(keyToAdd)) {
                    if (obj[keyToAdd] !== null && Array.isArray(obj[keyToAdd]) ) {
                        obj[keyToAdd].push(valueToAdd);
                    }
                    else if (obj[keyToAdd] !== null && !Array.isArray(obj[keyToAdd]) ) { 
                        obj[keyToAdd] = new Array(obj[keyToAdd], valueToAdd);
                    }
                }
                else{
                    obj[keyToAdd] = valueToAdd;
                }
                activeStart.push(valueToAdd.itemNum);
                return obj;
            }

            // Recursive step: Get the current key from the path
            const currentKey = path[0];

            // Check if the current key's value is an object before recursing
            if (typeof obj[currentKey] === 'object' && obj[currentKey] !== null) {
                addNestedProperty(obj[currentKey], path.slice(1), keyToAdd, valueToAdd);
            } else {
                obj[currentKey]={};
                addNestedProperty(obj[currentKey], path.slice(1), keyToAdd, valueToAdd);
            }
            return obj;
        }

        const call = async () => {
            config.isDebugEnabled && console.log("%cAPI - %c%s%c: \n%cModule Group ID:%c %s", logS.bold, logS.colors.skyblye, "Get Module Items",logS.none, logS.bold, logS.none, groupId, catModuleData);
            var url = "/api/ag/ct/document/list/item/" + groupId;
            return http.post(url, null);
        }
        return call().then((resp) => { 
            if(resp!=null){
                var res = convertCTResp(resp);

                if (res.status != 1) {
                    setStatusData({
                        title: ERROR_MESSAGES.DATA_ERROR.title,
                        message: res.globalErrorMessageList[0],
                        showContactHelp: true
                    })
                    setStatusVariant("error");
                    setShowStatusPopup(true); 
                }
                else {
                    setModuleItems(res.data);
                    var ids = [];

                    for(var x = 0 ; x<res.data.length ; x++){
                        var item = ((res.data)[x]);
                        var num = item.itemNum;
                        ids.push(item.id);
                        var split = removeExtrasFromItemNum(num);
                        addNestedProperty(items,split,'item',item);
                    }
                    setItemIds(ids);
                    setAllOpen([...activeStart]);
                    setActiveAccordion([...activeStart]);
                    
                    setEvents(items);
                    setIsLoading(false);
                }
            }
            return res;
        }).catch((error) => {
            config.isDebugEnabled && console.log(error);
            setStatusData({
                title: ERROR_MESSAGES.DATA_ERROR.title,
                message: ERROR_MESSAGES.DATA_ERROR.message,
                showContactHelp: true
            })
            setStatusVariant("error");
            setShowStatusPopup(true); 
        });

    }

    const handleActiveCommentChange = async (newId,checkEmpty) => {
        config.isDebugEnabled && console.log("%cInitiate %c- Active Key Change %c- %s -> %s", logS.bold, logS.colors.purple, logS.bold, activeCommentKey, newId, tempCommentList);
        var isSuccess = false;
        if(tempCommentList!=null && newId!=null){
            const entriesArray = Object.entries(tempCommentList);
            const filteredEntries = entriesArray.filter(([key, value]) => {
                return (value.status === "add" || value.status === "edit") && (newId!=null && newId!=key);
            });

            if(filteredEntries.length>0){
                var change = null;
                const results = await Promise.all(
                    filteredEntries.map(async entry => {
                        try {
                            var id = entry[0];
                            var value = entry[1];

                            var s = getCommentTempInputData(tempCommentList,id,"status");
                            var d = getCommentTempInputData(tempCommentList,id,"input");
                            const e = await validateCommentAPI(d.value, tabActiveKey, id, false,id );

                            if(s=="edit"){
                                checkEmpty=true;
                            }
                            else{
                                checkEmpty=false;
                            }

                            var r = getErrorList(e);
                            var result = {
                                item: getCommentTempInputData(tempCommentList,id),
                                errors: r
                            }
                            return result;
                        } 
                        catch (err) {
                            console.error(`Failed to validate ${id}`, err);
                            return;
                        }
                    })
                );

                for(var x = 0 ; x<results.length ; x++){
                    var r = results[x].errors;
                    var item = results[x].item;
                    var id = item.item.id;

                    var s = getCommentTempInputData(tempCommentList,id,"status");
                    var d = getCommentTempInputData(tempCommentList,id,"input");
                    
                    if(r!=null && r.length>0){
                        var arr = [];
                        var isEmpty = false;

                        if(s!=null){
                            if(s=="add"){
                                for(var x = 0 ; x<r.length ; x++){
                                    if(r[x].code==200){
                                        isEmpty=true;
                                    }
                                    else{
                                        arr.push(r[x].msg);
                                    }
                                }
                                if(isEmpty==true){
                                    if(change==null){
                                        change=true;
                                    }
                                    tempCommentListDispatch({
                                        type: COMMENT_ACTIONS.REMOVE_COMMENT,
                                        id: d.name
                                    });
                                }
                                else{
                                    change=false;
                                    tempCommentListDispatch({
                                        type: COMMENT_ACTIONS.TEXT_SET_ERRORS,
                                        errors: arr,
                                        name: d.name
                                    });

                                    config.isDebugEnabled && console.log("%cFocus %c- %s -", logS.colors.blue, logS.bold, item.item.itemNum, d);
                                    if (d.InputRef.current) {
                                        (d.InputRef.current).focus();
                                    }
                                }
                            }
                            if(s=="edit"){
                                if(commentsList!=null && commentsList.hasOwnProperty(id) && commentsMatch(commentsList[id].input.value, d.value) == true){
                                    if(change==null){
                                        change=true;
                                    }
                                    tempCommentListDispatch({
                                        type: "update-comment-status",
                                        name: id,
                                        status: 'view'
                                    })
                                }
                                else{
                                    for(var x = 0 ; x<r.length ; x++){
                                        arr.push(r[x].msg);
                                    }
                                    change=false;
                                    tempCommentListDispatch({
                                        type: COMMENT_ACTIONS.TEXT_SET_ERRORS,
                                        errors: arr,
                                        name: d.name
                                    });
                                    
                                    config.isDebugEnabled && console.log("%cFocus %c- %s -", logS.colors.blue, logS.bold, item.item.itemNum, d);
                                    if (d.EditRef.current) {
                                        (d.EditRef.current).focus();
                                    }
                                }
                            }
                        }
                    }
                    else{
                        if(change==null){
                            change=true;
                        }
                        var i = getCommentTempInputData(tempCommentList,id,"item");
                        
                        if(s!=null){
                            if(s==="add"){
                                commentsListDispatch({
                                    type: "add-comment",
                                    input: d,
                                    item: i,
                                    date: new Date()
                                });
                            }
                            if(s==="edit"){
                                if(commentsList!=null && commentsList.hasOwnProperty(id) && commentsMatch(commentsList[id].input.value, d.value) != true){
                                    commentsListDispatch({
                                        type: "update-comment",
                                        input: d,
                                        item: i,
                                        date: new Date()
                                    })
                                }
                            }
                        }
                        tempCommentListDispatch({
                            type: "update-comment-status",
                            name: id,
                            status: 'view'
                        })
                    }
                }
                
                if(change==true){
                    setActiveCommentKey(newId);
                    isSuccess=true;
                }
            }
            else{
                setActiveCommentKey(newId);
                isSuccess=true;
            }
        }

        if(isSuccess==true){
            config.isDebugEnabled && console.log("%cActive Key Change - %cSuccess%c - %s -> %s", logS.colors.purple, logS.colors.green, logS.bold,activeCommentKey, newId, tempCommentList);
        }
        else{
            config.isDebugEnabled && console.log("%cActive Key Change - %cFailed%c - %s -> %s", logS.colors.purple, logS.colors.red, logS.bold,activeCommentKey, newId, tempCommentList);
        }
        return isSuccess;
    }

    const validateSubmitAll = async ()=>{
        if(tempCommentList!=null){
            const entriesArray = Object.entries(tempCommentList);
            const filteredEntries = entriesArray.filter(([key, value]) => {
                return (value.status === "add" || value.status === "edit");
            });

            if(Object.entries(filteredEntries).length<1){
                setShowThankYouPopup(true);
            }
            else{ 
                var change = null;
                const results = await Promise.all(
                    filteredEntries.map(async entry => {
                        var checkEmpty = null;
                        try {
                            var id = entry[0];

                            var s = getCommentTempInputData(tempCommentList,id,"status");
                            var d = getCommentTempInputData(tempCommentList,id,"input");
                            const e = await validateCommentAPI(d.value, tabActiveKey, id, false,id );

                            if(s=="edit"){
                                checkEmpty=true;
                            }
                            else{
                                checkEmpty=false;
                            }
                            var r = getErrorList(e);
                            var result = {
                                item: getCommentTempInputData(tempCommentList,id),
                                errors: r
                            }
                            return result;
                        } catch (err) {
                            console.error(err);
                            return null; // fallback value
                        }
                    })
                );
                
                for(var x = 0 ; x<results.length ; x++){
                    var r = results[x].errors;
                    var item = results[x].item;
                    
                    var id = item.item.id;
                    var s = getCommentTempInputData(tempCommentList,id,"status");
                    var d = getCommentTempInputData(tempCommentList,id,"input");
                    if(r!=null && r.length>0){
                        var arr = [];
                        var isEmpty = false;

                        if(s!=null){
                            if(s=="add"){
                                for(var x = 0 ; x<r.length ; x++){
                                    if(r[x].code==200){
                                        isEmpty=true;
                                    }
                                    else{
                                        arr.push(r[x].msg);
                                    }
                                }
                                if(isEmpty==true){
                                    if(change==null){
                                        change=true;
                                    }
                                    tempCommentListDispatch({
                                        type: COMMENT_ACTIONS.REMOVE_COMMENT,
                                        id: d.name
                                    });
                                }
                                else{
                                    change=false;
                                    tempCommentListDispatch({
                                        type: COMMENT_ACTIONS.TEXT_SET_ERRORS,
                                        errors: arr,
                                        name: d.name
                                    });

                                    config.isDebugEnabled && console.log("%cFocus %c- %s -", logS.colors.blue, logS.bold, item.item.itemNum, d);
                                    if (d.InputRef.current) {
                                        (d.InputRef.current).focus();
                                    }
                                }
                            }
                            if(s=="edit"){
                                if(commentsList!=null && commentsList.hasOwnProperty(id) && commentsMatch(commentsList[id].input.value, d.value) == true){
                                    if(change==null){
                                        change=true;
                                    }
                                    tempCommentListDispatch({
                                        type: "update-comment-status",
                                        name: id,
                                        status: 'view'
                                    })
                                }
                                else{
                                    for(var x = 0 ; x<r.length ; x++){
                                        //console.log(r[x]);
                                        arr.push(r[x].msg);
                                    }
                                    change=false;
                                    tempCommentListDispatch({
                                        type: COMMENT_ACTIONS.TEXT_SET_ERRORS,
                                        errors: arr,
                                        name: d.name
                                    });

                                    

                                    config.isDebugEnabled && console.log("%cFocus %c- %s -", logS.colors.blue, logS.bold, item.item.itemNum, d);
                                    if (d.EditRef.current) {
                                        (d.EditRef.current).focus();
                                    }
                                }
                            }
                        }
                    }
                    else{
                        if(change==null){
                            change=true;
                        }
                        var i = getCommentTempInputData(tempCommentList,id,"item");
                        
                        if(s!=null){
                            if(s=="add"){
                                commentsListDispatch({
                                    type: "add-comment",
                                    input: d,
                                    item: i,
                                    date: new Date()
                                });
                            }
                            if(s=="edit"){
                                
                                if(commentsList!=null && commentsList.hasOwnProperty(id) && commentsMatch(commentsList[id].input.value, d.value) != true){
                                    commentsListDispatch({
                                        type: "update-comment",
                                        input: d,
                                        item: i,
                                        date: new Date()
                                    })
                                }
                            }
                        }

                        tempCommentListDispatch({
                            type: "update-comment-status",
                            name: id,
                            status: 'view'
                        })
                        
                    }
                }
                if(change==true){
                    setShowThankYouPopup(true);
                }
            }
        }
    }
    

    
    const callback = (entries, observer) => {
        entries.forEach((entry) => {
            var sticky = (!entry.isIntersecting) && entry.boundingClientRect.top < 0;
            if(sticky!=isSticky){
                //if(defaultSearchTerm!=null){
                    //setIsSticky(true);
                //}
                //else{
                    setIsSticky((!entry.isIntersecting) && entry.boundingClientRect.top < 0);
                //}
            }
        });
    };
    
    useEffect(() => {
        if (!sentinelRef.current) return;
        const observer = new IntersectionObserver(callback,options);
        if (sentinelRef.current) {
            observer.observe(sentinelRef.current);
        }
    }, [sentinelRef,options, defaultSearchTerm]);
   
    return (
        <>
            <ReCaptchaWrapper
                action="comment_tool_landing"
                title="Common Formats - Provide Feedback"
            >
                {showThankYouPopup == true
                    ?   <ThankYou
                            show={showThankYouPopup}
                            handleClose={handleThankYouClose}
                            comments={commentsList}
                            submitType={"cf"}
                            categoryId={tabActiveKey}
                            tempCommentListDispatch={tempCommentListDispatch}
                            commentsListDispatch={commentsListDispatch}
                            setStatusData={setStatusData}
                            setStatusVariant={setStatusVariant}
                            setShowStatusPopup={setShowStatusPopup}
                        >
                        </ThankYou>
                    :   null
                }
                {
                    showStatusPopup == true && statusVariant != null
                    ?
                        <StatusPopup
                            show={showStatusPopup}
                            handleClose={handleStatusClose}
                            title={statusData.title}
                            variant={statusVariant}
                            message={statusData.message}
                            buttons={statusData.buttons}
                            showStatusPopup={statusData?.showContactHelp}
                        ></StatusPopup>
                    :   null
                }
                
                <Row className="m-0 p-0 gap-80 commenting-tool">
                    <div className="public-header m-0 d-flex flex-column justify-content-center w-100 g-0">
                        <Row className="d-flex flex-column flex-md-row justify-content-center w-100 m-0 p-0 gap-4 gap-0 g-4 horiz-header col-xxl-9 col-xl-11 col-lg-11 col-md-11 col-sm-12" >
                                <Col className={"d-flex flex-column pe-md-3 gap-4 g-0 mt-0 pt-0"} md={6} lg={6} xl={6} xxl={5}>
                                    <h1 id="mainContent" className={"displayXL bold color-white text-center text-md-start mb-0"}>Provide Feedback</h1>
                                    <p className="body  public-intro text-center text-md-start mb-0" >
                                        To improve the Common Formats, we need your feedback. Use the form below to provide your real world input and perspective. The PSOPPC will then convene a Common Formats Expert Panel who will review submitted public comments and provide recommendations to AHRQ for how to update existing, or create new, Common Formats.
                                    </p>
                                </Col>
                                <Col className={"pb-0 d-flex justify-content-center ps-md-3 mt-0 g-0"} md={5} lg={5} xl={5} xxl={4}>
                                    <img src={feedbackIcon} alt="Feedback Loop" className="feedback-loop"></img>
                                </Col>
                        </Row>
                    </div>
                    
                    <Row className=" m-0 p-0 d-flex justify-content-center">
                        <Col xxl={9} xl={11} lg={11} md={11} sm={12} className="px-3 px-md-0">
                            <h2 className="bold displayS color-193F64 mb-4 text-start">Commenting Tool</h2>
                            <p className="body semilight text-start mb-4">
                                You can search terms across all Common Formats versions, browse by a specific version, or provide feedback on individual event descriptions within a Common Formats version. For general feedback not tied to a specific version or event description, use the General tab.
                            </p>
                            <p className="body semilight text-start mb-0">
                                Please select the <b>Common Formats version</b> you're interested in providing feedback.
                            </p>
                            <ul className="ctul body semilight text-start mb-0">
                                <li>Choose an <b>event type</b> below to load its descriptions.</li>
                                <li>Select any element to enter your comments.</li>
                                <li>Upon selection, a text box will appear near the <b>individual element.</b></li>
                                <li>Click <b>Submit All Comments</b>  to finalize your feedback for this version.</li>
                            </ul>
                            <p className="d-block d-md-none body semilight text-start mb-0 mt-4"><i>For a better provide feedback experience, consider using the desktop format.</i></p>
                        </Col>
                    </Row>
                    
                    {/**commenting tool section */}
                    <Row className="justify-content-center comment-tool-card p-0 m-0 ">
                        
                        {/* 
                            NEW 
                            xxl={9} xl={11} lg={11} md={11} sm={12}

                            OLD
                            xxl={11} xl={12} lg={12} md={12} sm={12}
                        */}
                        
                        <Col xxl={10} xl={12} lg={12} md={12} sm={12} className="p-0">
                            <Card className="mb-80px ct-blue-bg-card" >
                                <Card.Body className="text-start p-0 d-flex flex-column gap-4 " >
                                    <div  className="sticky-trigger position-absolute col-lg-7 col-md-8 col-sm-12" />
                                    <Col className={"d-flex flex-column flex-lg-row justify-content-between gap-4"} ref={sentinelRef}>
                                        {/*  */}
                                        <Col sm={12} md={12} lg={7} id="floating-search" className={"p-0" + (isSticky == true ? " ": " ")} >{/*position-fixed top-0*/}
                                            
                                                <div
                                                    className="p-0"
                                                >
                                                    <SearchBar
                                                        defaultSearchTerm={defaultSearchTerm}
                                                        getSearchModuleData={getSearchModuleData}
                                                        items={moduleItems}
                                                        highlighted={highlighted}
                                                        setHighlighted={setHighlighted}
                                                        categoryId={tabActiveKey}
                                                        moduleKey={eventTypeActiveKey}
                                                        setModuleKey={setEventTypeActiveKey}
                                                        handleModuleChange={confirmModuleChange}
                                                        handleCategoryChange={confirmCatTabChange}
                                                        eventTypeList={eventTypeList}
                                                        comonFormatsList={comonFormatsList}
                                                        //moduleCount={moduleCount}
                                                        itemListRefs={itemListRefs}
                                                        focusKeywordId={focusKeywordId}
                                                        setFocusKeywordId={setFocusKeywordId}
                                                        setActiveSearch={setActiveSearch}
                                                        activeSearch={activeSearch}
                                                        searchTerm={searchTerm}
                                                        setSearchTerm={setSearchTerm}
                                                        isSticky={isSticky}
                                                        moduleHeaderRef={moduleHeaderRef}
                                                        itemIndexes={itemIndexes}
                                                        setItemIndexes={setItemIndexes}
                                                        resultCategories={resultCategories}
                                                        setResultCategories={setResultCategories}
                                                        resultIndex={resultIndex}
                                                        setResultIndex={setResultIndex}
                                                        moduleCount={moduleCount}
                                                        setModuleCount={setModuleCount}
                                                    ></SearchBar>
                                                </div>
    
                                        </Col>
                                        
                                        <Col lg="auto">
                                            <div>
                                            {
                                                tabActiveKey!=0
                                                ?
                                                    <TextButton
                                                        id="ct-save-all-btn"
                                                        content="Submit All Comments"
                                                        variant="comp-primary"
                                                        size="lg"
                                                        className="ms-md-auto px-80px body w-xs-100 w-lg-fit-content "
                                                        onClick={()=>{
                                                            const entriesArray = Object.entries(tempCommentList);
                                                            //console.log(entriesArray);
                                                            if(entriesArray!=null && entriesArray.length>0){
                                                                validateSubmitAll();
                                                            }
                                                            else{
                                                                setStatusData({
                                                                    title: "Submission Error",
                                                                    message: "At least one comment is required. Please add a comment.",
                                                                    buttons: null
                                                                })
                                                                setStatusVariant("warning");
                                                                setShowStatusPopup(true);
                                                            }
                                                        }}
                                                    ></TextButton>
                                                :   null
                                            }
                                            </div>
                                        </Col>
                                    </Col>
                                   {
                                        comonFormatsList != null
                                        ?
                                            <>
                                                <Tab.Container
                                                    id="ct-tabs"
                                                    activeKey={tabActiveKey}
                                                    defaultActiveKey={defaultCF!=null ? defaultCF : 0}
                                                    mountOnEnter={true}
                                                    unmountOnExit={true}
                                                    variant="ct"
                                                    ref={scrollRef}
                                                >
                                                    
                                                    {/* <Accordion.Body> */}
                                                    <div className="my-0 bg-color-base-white w-lg-fit-content">
                                                        {/* floating */}
                                                        <Button
                                                            className="d-flex d-lg-none body bold"
                                                            onClick={() => setIsCFDropdownOpen(!isCFDropdownOpen)}
                                                            aria-controls="ct-drop-menu"
                                                            aria-expanded={isCFDropdownOpen}
                                                            variant="ct-drop"
                                                            ref={cfDropBtnRef}
                                                        >
                                                            {getCFName(tabActiveKey, comonFormatsList)}
                                                            <svg className={isCFDropdownOpen==false ? "down-icon" : 'up-icon'} xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
                                                                <path d="M1.41 7.41L6 2.83L10.59 7.41L12 6L6 3.8147e-06L0 6L1.41 7.41Z" fill="#1D6193"/>
                                                            </svg>
                                                        </Button>
                                                        <Collapse id="ct-drop-menu" in={isCFDropdownOpen} appear={false} timeout={0} className="d-lg-block ct-drop-menu">
                                                            <div>
                                                                <Nav
                                                                    id="ct-tabs"
                                                                    onSelect={(k) => {
                                                                        //console.log(k);
                                                                        confirmCatTabChange(k);
                                                                        setIsCFDropdownOpen(false);
                                                                        (cfDropBtnRef.current).focus();
                                                                    }}
                                                                    variant="ct"
                                                                >
                                                                    <>
                                                                        {
                                                                            comonFormatsList != null
                                                                            ?
                                                                                comonFormatsList.map((cat, index) => {
                                                                                    if(cat.opForCmnt==1){
                                                                                        var {name, version} = getCFSplitName(cat.shortName);
                                                                                        return (
                                                                                            <Nav.Item key={cat.id}>
                                                                                                <Nav.Link eventKey={cat.id} as={"button"}  role={"navigation"} disabled={cat.id == tabActiveKey ? "disabled" : ""}>
                                                                                                    <div className="d-none d-lg-flex flex-column align-items-center">
                                                                                                        <div className="d-flex flex-row position-absolute align-items-center">
                                                                                                            <span className="tab-name">{name}</span>
                                                                                                            <Badge bg="version">{version}</Badge>
                                                                                                        </div>
                                                                                                        <div aria-hidden="true" className=" hide d-flex flex-row align-items-center">
                                                                                                            <span className="bold-sizer" >{name}</span>
                                                                                                            <Badge className="hide-ver" bg="version">{version}</Badge>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="d-flex d-lg-none flex-column align-items-start">
                                                                                                        <div className="d-flex flex-row position-relative align-items-start">
                                                                                                            <span className="tab-name">{cat.shortName}</span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </Nav.Link>
                                                                                            </Nav.Item>
                                                                                        );
                                                                                    }
                                                                                })
                                                                            :   null
                                                                        }
                                                                        <Nav.Item>
                                                                            <Nav.Link eventKey={0} as={"button"} role={"navigation"} disabled={0 == tabActiveKey ? "disabled" : ""}>
                                                                                <div className="d-none d-lg-flex flex-column align-items-center">
                                                                                    <div className="d-flex flex-row position-absolute align-items-center">
                                                                                        <span className="tab-name">General</span>
                                                                                    </div>
                                                                                    <div aria-hidden="true" className=" hide d-flex flex-row align-items-center">
                                                                                        <span className="bold-sizer" >General</span>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="d-flex d-lg-none flex-column align-items-start">
                                                                                    <div className="d-flex flex-row position-relative align-items-start">
                                                                                        <span className="tab-name">General Comments</span>
                                                                                    </div>
                                                                                </div>
                                                                            </Nav.Link>
                                                                        </Nav.Item>
                                                                    </>
                                                                </Nav>
                                                            </div>
                                                        </Collapse>
                                                    </div>
    
                                                    <Tab.Content>
                                                        <Tab.Pane eventKey={tabActiveKey}>
                                                            {
                                                                tabActiveKey==0
                                                                ?
                                                                    <GeneralComment
                                                                        setStatusData={setStatusData}
                                                                        setStatusVariant={setStatusVariant}
                                                                        setShowStatusPopup={setShowStatusPopup}
                                                                        generalFeedback={generalFeedback}
                                                                        generalFeedbackInputDispatch={generalFeedbackInputDispatch}
                                                                    ></GeneralComment>
                                                                :
                                                                    <div className="d-flex flex-column gap-4 mt-0">
                                                                    {
                                                                        eventTypeList!=null && eventTypeList.length>1 && eventTypeActiveKey!=null
                                                                        ?
                                                                            <EventTypeSelection
                                                                                activeKey={eventTypeActiveKey}
                                                                                setActiveKey={setEventTypeActiveKey}
                                                                                handleModuleChange={confirmModuleChange}
                                                                                eventTypeList={eventTypeList}
                                                                                setEventTypeList={eventTypeList}
                                                                            ></EventTypeSelection>
                                                                            
                                                                        : null
                                                                    }
                                                                    {
                                                                        catModuleData!=null
                                                                        ?
                                                                            <EventTypeHeader
                                                                                moduleHeaderRef={moduleHeaderRef}
                                                                                focusKeywordId={focusKeywordId}
                                                                                shortName={catModuleData.shortName}
                                                                                displayName={catModuleData.dispName}
                                                                                categoryId={tabActiveKey}
                                                                                cfName={getCFName(tabActiveKey, comonFormatsList)}
                                                                                allOpen={allOpen}
                                                                                setActiveAccordion={setActiveAccordion}
                                                                                tabActiveKey={tabActiveKey}
                                                                                tempCommentList={tempCommentList}
                                                                                tempCommentListDispatch={tempCommentListDispatch}
                                                                                commentsList={commentsList}
                                                                                commentsListDispatch={commentsListDispatch}
                                                                                
                                                                            ></EventTypeHeader>
                                                                        : null
                                                                    }
                                                                    {
                                                                        events!=null && isLoading==false
                                                                        ?
                                                                            <ItemList
                                                                                defaultFocusItem={defaultFocusItem}
                                                                                setDefaultFocusItem={setDefaultFocusItem}
                                                                                itemListRefs={itemListRefs}
                                                                                setItemListRefs={setItemListRefs}
                                                                                events={events}
                                                                                activeAccordion={activeAccordion}
                                                                                setActiveAccordion={setActiveAccordion}
                                                                                activeEl={activeEl}
                                                                                setActiveEl={setActiveEl}
                                                                                commentsList={commentsList}
                                                                                commentsListDispatch={commentsListDispatch}
                                                                                moduleItems={moduleItems}
                                                                                mobile={mobile}
                                                                                commentInput={commentInput}
                                                                                commentInputDispatch={commentInputDispatch}
                                                                                tempCommentList={tempCommentList}
                                                                                tempCommentListDispatch={tempCommentListDispatch}
                                                                                activeCommentKey={activeCommentKey}
                                                                                setActiveCommentKey={setActiveCommentKey}
                                                                                categoryId={tabActiveKey}
                                                                                handleActiveCommentChange={handleActiveCommentChange}
                                                                                setActiveSearch={setActiveSearch}
                                                                                activeSearch={activeSearch}
                                                                                handleStatusClose={handleStatusClose}
                                                                                setStatusData={setStatusData}
                                                                                setStatusVariant={setStatusVariant}
                                                                                setShowStatusPopup={setShowStatusPopup}
    
                                                                                highlighted={highlighted}
                                                                                setHighlighted={setHighlighted}
                                                                                focusKeywordId={focusKeywordId}
                                                                            ></ItemList>
                                                                        :   null
                                                                    }
                                                                </div>
                                                            }
                                                        </Tab.Pane>
                                                    </Tab.Content>
                                                </Tab.Container>
                                            </>
                                        :   null
                                    }
                                    <Fade in={isSticky} appear={false} className="fade-regular" >
                                        <div>
                                            <OverlayTrigger
                                                placement={"top"}
                                                //show={isSticky}
                                                overlay={
                                                    <Tooltip id="submit-all-tooltip" >
                                                        Submit All
                                                    </Tooltip>
                                                }
                                            >
                                                <IconButton
                                                    disabled={!isSticky}
                                                    ref={iconRef}
                                                    id="ct-save-all-btn-icon"
                                                    content="Submit All Comments"
                                                    variant="comp-secondary"
                                                    size="lg"
                                                    icon={ICONS.send}
                                                    className={"ms-md-auto body p-2" + (isSticky == true ? " is-stuck-exit": "  is-stuck-exit")}
                                                    onClick={()=>{
                                                        const entriesArray = Object.entries(tempCommentList);
                                                        if(entriesArray!=null && entriesArray.length>0){
                                                            validateSubmitAll();
                                                        }
                                                        else{
                                                            setStatusData({
                                                                title: "Submission Error",
                                                                message: "At least one comment is required. Please add a comment.",
                                                                buttons: null
                                                            })
                                                            setStatusVariant("warning");
                                                            setShowStatusPopup(true);
                                                        }
                                                    }}
                                                    hiddenText={"Submit All Comments"}
                                                ></IconButton>
                                            </OverlayTrigger>
                                        
                                        </div>
                                    </Fade>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
    
                </Row>
                <div ref={sentinelExitRef} className="sticky-trigger exit position-absolute col-lg-7 col-md-8 col-sm-12" />
            </ReCaptchaWrapper>
        </>
    )
}

export default OpenForComment;